import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable, of} from 'rxjs';
import {mergeMap, take} from 'rxjs/operators';
import {Client, KcApplicationClient, KcProgram} from '../services/api.client';
import {ClientService} from '../services/ClientService';

@Injectable()
export class ResolveKcPrograms  {

    client: Client;
    client$: Observable<Client>;

    constructor(private _kcAppClient: KcApplicationClient, private _clientService: ClientService) {
        this.client$ = this._clientService.currentClient$;
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<KcProgram[]> | Promise<KcProgram[]> | KcProgram[] {
        return this.client$.modelExists().pipe(
            take(1),
            mergeMap((client) => {
                if (client.federalPovertyLevelDisplay !== null && client.federalPovertyLevelDisplay !== undefined) {
                    return this._kcAppClient.retrieveKcPrograms(client.federalPovertyLevelDisplay);
                }
                return of([]);
            })
        );
    }
}
